module.exports = __webpack_public_path__ + "static/scrum_icon-717c8e8a01dfbbccb2f32de9518a4217.svg";